/* eslint-disable react-hooks/exhaustive-deps */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Card,
  CardActions,
  CardContent,
  Collapse,
  Typography,
} from '@mui/material';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BulkDocumentResponse } from '@efex-services/documents/types';
import { StateSpan } from '@constants/states';
import useImmediateApiCall from '../../hooks/useImmediateApiCall';
import documentsSvc from '../../services/documents/documentsSvc';
import { convertDateToHumanReadable } from '../../utils/formater';
import DataLoadingWrapper from '../common/DataLoadingWrapper';
import ExpandMore from '../common/ExpandMore';

interface IBulksPayablesTablePRops {
  shouldReloadFiles: boolean;
  filesReloaded: () => void;
}

const BulksPayablesTable = ({
  shouldReloadFiles,
  filesReloaded,
}: IBulksPayablesTablePRops) => {
  const { t, i18n } = useTranslation();
  const {
    data: bulkDocuments,
    loading,
    retry: getFiles,
  } = useImmediateApiCall(() => documentsSvc.getFiles());
  const [expanded, setExpanded] = useState<boolean>(true);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (shouldReloadFiles) {
      getFiles();
      filesReloaded();
    }
  }, [shouldReloadFiles]);

  return (
    <Card className="px-2">
      <CardActions disableSpacing>
        <Typography variant="h6">{t('pyMyFiles')}</Typography>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <DataLoadingWrapper
            className="min-h-[275px] flex justify-center items-center"
            loadingData={loading}
          >
            <table className="mt-5" style={{ overflow: 'auto' }}>
              <thead>
                <tr>
                  <th className="!lowercase first-letter:capitalize p-3">
                    {t('filename')}
                  </th>
                  <th className="!lowercase first-letter:capitalize p-3">
                    {t('exchangeRate')}
                  </th>
                  <th className="!lowercase first-letter:capitalize p-3">
                    {t('status')}
                  </th>
                  <th className="!lowercase first-letter:capitalize p-3">
                    {t('creationDate')}
                  </th>
                </tr>
              </thead>
              <tbody className="bg-primary-fill">
                {bulkDocuments?.map((document: BulkDocumentResponse) => (
                  <tr key={`item-${document.id}`}>
                    <td>
                      <section className="flex py-1 items-center">
                        <a
                          className="underline decoration-solid text-primary-text hover:text-secondary-text"
                          href={`${document.document}`}
                        >
                          <p className="m-0 ml-1 text-sm inline">
                            {
                              document.document
                                .split('/')
                                [document.document.split('/').length - 1].split(
                                  '?'
                                )[0]
                            }
                          </p>
                        </a>
                      </section>
                    </td>
                    <td>{document.rate}</td>
                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                    <td>
                      <StateSpan status={document.status} />
                    </td>
                    <td className="PaymentDuedate">
                      {convertDateToHumanReadable(
                        document.created_at,
                        i18n.language,
                        DateTime.DATETIME_MED
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </DataLoadingWrapper>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default BulksPayablesTable;
